import { atom } from '@reatom/framework'

import type { ShortcutId } from '../shortcut-id'

export const reatomPossibleShortcutAtom = atom<ShortcutId | undefined>(
  undefined,
  'reatomPossibleShortcutAtom',
)
